<template>
  <div>
    <div>
      <el-card shadow="never">
        <div style="display: flex;justify-content: space-between; align-items: center;width: 100%;">
          <div style="display: inline-block;">
            <el-badge is-dot class="item">快速筛选订单:</el-badge>
            <el-badge value="14" class="item">
              <el-button @click="changeIndex(1)" :class="{'selected1': selectedIndex ===1}" size="small">待处理</el-button>
            </el-badge>
            <el-badge value="30" class="item">
              <el-button @click="changeIndex(2)" :class="{'selected1': selectedIndex ===2}" size="small">退款进行中</el-button>
            </el-badge>
            <el-badge value="14" class="item">
              <el-button @click="changeIndex(3)" :class="{'selected1': selectedIndex ===3}" size="small">已完成</el-button>
            </el-badge>
            <el-badge value="30" class="item">
              <el-button @click="changeIndex(4)" :class="{'selected1': selectedIndex ===4}" size="small">已拒绝</el-button>
            </el-badge>
          </div>
        </div>
      </el-card>
      <el-card shadow="never">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="申诉搜索">
            <el-input v-model="formInline.user" placeholder="请输入订单编号/售后编号/手机号/商品ID"></el-input>
          </el-form-item>
          <el-form-item label="售后类型">
            <el-select v-model="value" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申诉时间">
            <el-date-picker
                v-model="formInline.value1"
                type="date"
                placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
        <div style="width:300px;display: inline-block;margin-right: 20px;">
          <el-button v-if="isApplyExport" size="medium" type="primary">导出</el-button>
        </div>
      </el-card>

      <el-card shadow="never">
        <el-table
            :data="tableData"
            border
            style="width: 100%">
          <el-table-column
              prop="data"
              label="订单号"
              width="180">
          </el-table-column>
          <el-table-column
              prop="name"
              label="申诉时间"
              width="180">
          </el-table-column>
          <el-table-column
              prop="address"
              label="申诉单号">
          </el-table-column>
          <el-table-column
              prop="address"
              label="申诉原因">
          </el-table-column>
          <el-table-column
              prop="address"
              label="申诉凭证">
          </el-table-column>
          <el-table-column
              prop="address"
              label="申诉状态">
          </el-table-column>
          <el-table-column
              prop="address"
              label="平台处理结果">
          </el-table-column>
          <el-table-column
              prop="address"
              label="平台处理意见">
          </el-table-column>
          <el-table-column
              prop="address"
              label="商品信息">
          </el-table-column>
          <el-table-column
              prop="address"
              label="下单信息">
          </el-table-column>
          <el-table-column
              prop="address"
              label="金额">
          </el-table-column>
          <el-table-column
              prop="address"
              label="金额">
          </el-table-column>
          <el-table-column
              prop="address"
              label="数量">
          </el-table-column>
          <el-table-column
              prop="address"
              label="售后类型">
          </el-table-column>
          <el-table-column
              prop="address"
              label="发货状态">
          </el-table-column>
          <el-table-column
              prop="address"
              label="售后状态">
          </el-table-column>
          <el-table-column
              prop="address"
              label="驳回原因">
          </el-table-column>
          <el-table-column
              fixed="right"
              align="center"
              width="300"
              label="操作">
            <template slot-scope="scope">
              <div>
                <el-button @click="goDetails" v-if="isApplyDetail" size="mini" type="success">查看详情</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>
<script>
import {getButtonList} from "../../../promissionRouter";

export default {
  name: "RefundGoods",
  data(){
    return {
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      isApplyExport:false,
      isApplyDetail:false,
      tableData:[{data:'123'}],
      selectedIndex: 1,
      formInline: {
        user: '',
        region: '',
        value1:''
      },
      total: 0,
    }
  },
  mounted() {
    // const myScroll = new IScroll('#scroll', {
    //   //按照需求添加横向滚动的配置项
    // });
    //更新
    // console.log('myScroll',myScroll)
    // myScroll.refresh();

    // this.getSpusOnSale();
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      if (this.buttonList_toolBar && this.buttonList_toolBar.length > 0){
        this.buttonList_toolBar.forEach((item,index) =>{
          if (item.buttonFunc === "applyExport") {
            this.isApplyExport = true;
          }
        })
      }
      console.log(toolBarButtonList,'toolBarButtonList')
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
      if (this.buttonList_table && this.buttonList_table.length > 0){
        this.buttonList_table.forEach((item,index) =>{
          if (item.buttonFunc === "applyDetail") {
            this.isApplyDetail = true;
          }
        })
      }
    }
    // console.log('buttonList', buttonList)
    // console.log('toolBarButtonList', this.buttonList_toolBar)
    // console.log('buttonList_table', this.buttonList_table)
  },
  methods: {
    goDetails(){
      this.$router.push('/AfterSalesService/AfterSaleList/Detail')
    },
    refuse(){
      this.$confirm("确认拒绝退货吗?", "提示", {
        closeOnClickModal: false,
        //type: 'warning'
      })
          .then(() => {

          })
          .catch((err) => {
            console.log(err)
          });
    },
    refundGoods(){
      this.$confirm("确认退货吗?", "提示", {
        closeOnClickModal: false,
        //type: 'warning'
      })
          .then(() => {

          })
          .catch((err) => {
            console.log(err)
          });
    },
    changeIndex(i){
      this.selectedIndex = Number(i);
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSizeChange(val) {
      // this.pageSize = val
      // this.pageIndex = 1
      // this.getTableList()
    },
    handleCurrentChange(val) {
      // this.pageIndex = val
      // this.getTableList()
    },
  }
}
</script>



<style scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
/deep/ .selected1 {
  background-color: #ecf5ff;
  color:#409eff;
}
.pagination {
  text-align: right;
  margin-top: 15px;
}
</style>